import { ChevronLeft, ChevronLeftCircle, ChevronRightCircle, Footprints, Goal, X } from 'lucide-react';
import React, { useState, useEffect } from 'react';
import { FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { motion, useMotionValue, animate } from "framer-motion";
import TeamSlider from '../components/TeamSlider';

export default function About() {
  const [visibleSections, setVisibleSections] = useState(new Set());
  
  const [active, setActive] = useState(0);

  const [selectedProject, setSelectedProject] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [about, setAbout] = useState([]);
  const [mission, setMission] = useState([]);

  const items = [
    { title: "Reliable", icon: "/images/radar/reliable.png" },
    { title: "Accurate", icon: "/images/radar/accurate.png" },
    { title: "Dedicated", icon: "/images/radar/dedicated.png" },
    { title: "Advanced", icon: "/images/radar/advanced.png" },
    { title: "Responsive", icon: "/images/radar/responsive.png" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % items.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const size = 700;
  const center = size / 2;
  const radius = 280; // jarak dari tengah

  // hitung posisi segi lima secara matematis
  const coords = items.map((_, i) => {
    const angle = (i * 72 - 90) * (Math.PI / 180);
    return {
      x: center + radius * Math.cos(angle),
      y: center + radius * Math.sin(angle),
    };
  });

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('[data-section]');
      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight * 0.75 && rect.bottom > 0;
        
        if (isVisible) {
          setVisibleSections(prev => new Set([...prev, section.getAttribute('data-section')]));
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const [filter, setFilter] = useState('all');
  
    useEffect(() => {
      const handleScroll = () => {
        const sections = document.querySelectorAll('[data-section]');
        sections.forEach(section => {
          const rect = section.getBoundingClientRect();
          const isVisible = rect.top < window.innerHeight * 0.75 && rect.bottom > 0;
          
          if (isVisible) {
            setVisibleSections(prev => new Set([...prev, section.getAttribute('data-section')]));
          }
        });
      };
  
      window.addEventListener('scroll', handleScroll);
      handleScroll();
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const [dataGallery, setDataGallery] = useState([]);
    const [dataTeam, setDataTeam] = useState([]);
    const [page, setPage] = useState(1);
    const [pageTeam, setPageTeam] = useState(1);
    const [total, setTotal] = useState(1);
    const [totalTeam, setTotalTeam] = useState(1);
    const [category, setCategory] = useState("");

    const fetchDataGallery = async () => {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/gallery?page=${page}&category=${category}`
      );
      const json = await res.json();

      setDataGallery(json.data);
      setTotal(json.total_pages);
    };

    useEffect(() => {
      fetchDataGallery();
    }, [page, category]);

    const fetchDataTeam = async () => {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/teams`
      );
      const json = await res.json();

      setDataTeam(json.data);
      setTotalTeam(json.total_pages);
    };

    useEffect(() => {
      fetchDataTeam();
    }, [pageTeam, category]);
  
    const categories = [
      { id: 'all', name: 'Semua Foto & Video' },
      { id: 'anniv', name: 'Anniversary Kenzie Komunika' },
      { id: 'liburan', name: 'Kenzie Komunika Liburan' },
      { id: 'tahunan', name: 'Acara Tahunan Kenzie Komunika' },
      { id: 'berbagi', name: 'Kenzie Komunika Berbagi' },
    ];
  
    const filteredProjects = filter === 'all' 
      ? dataGallery 
      : dataGallery.filter(p => p.category === filter);

    const fetchAbout = async () => {
      
      try {
          const res = await fetch(
              `${process.env.REACT_APP_BASE_URL}api/about/1`
          );
  
          if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  
          const json = await res.json();
          setAbout(json.data || []);
  
      } catch (err) {
          console.error("Fetch About error:", err);
      }
    };
    
    useEffect(() => {
      fetchAbout();
    }, []);  

    const fetchMission = async () => {
        try {
          const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/mission`);
    
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
    
          const note = await res.json();
          const list = Array.isArray(note) ? note : note.data || [];
    
          setMission(list);
        } catch (err) {
          console.error("Gagal mengambil data:", err);
        }
      };
        
      useEffect(() => {
        fetchMission();
      }, []);
    
    const x = useMotionValue(0);

  const loopData = [...dataTeam, ...dataTeam];

    useEffect(() => {
      const controls = animate(x, -2000, {
        ease: "linear",
        duration: 25,
        repeat: Infinity,
        repeatType: "loop"
      });

      return controls.stop;
    }, []);
    

  return (
    <div className="min-h-screen bg-slate-100/95 text-slate-700">
      {/* Header Section */}
      <section 
        data-section="header"
        className="py-24 bg-gradient-to-b from-slate-900 to-slate-950 pt-40 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <img
            src="/images/bg-hero-about-us.jpeg"
            alt="background"
            className="w-full h-full object-cover opacity-20"
          />
        </div>

        <div className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 ${
          visibleSections.has('header') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h1 className="font-bricolage text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-red-500 to-[#3E3274]  bg-clip-text text-transparent">
            Tentang Kami
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-red-500 to-[#3E3274] mx-auto mb-6"></div>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Kenzie Komunika merupakan distributor pulsa terkemuka dengan skala nasional, beroperasi di Bandung dan melebarkan sayapnya dipenjuru Indonesia.
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section 
        data-section="story"
        className="py-24 bg-white"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200 ${
          visibleSections.has('story') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <h1 className="text-6xl font-bold font-bricolage bg-gradient-to-r from-red-500 to-[#3E3274]  bg-clip-text text-transparent">{about.title}</h1>
              <p className="text-slate-700 text-lg leading-relaxed">
                {about.description}
              </p>
            </div>

            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-red-500/30 to-blue-800/30 rounded-2xl blur-2xl"></div>
              <div className="relative bg-white backdrop-blur-sm p-8 rounded-2xl border border-[#3E3274]">
                <div className="space-y-4">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 text-white bg-gradient-to-br from-red-500 to-[#3E3274] rounded-lg flex items-center justify-center flex-shrink-0">
                      <span className="text-2xl"><Goal size={36}></Goal></span>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold mb-2 font-bricolage">Visi</h3>
                      <p className="text-slate-700">{about.visi}</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 text-white bg-gradient-to-br from-red-500 to-[#3E3274] rounded-lg flex items-center justify-center flex-shrink-0">
                      <span className="text-2xl"><Footprints size={36}></Footprints></span>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold mb-2 font-bricolage">Misi</h3>
                      <ol class="list-decimal list-outside text-slate-700 ml-4">
                        {mission.map((item, index) => (
                          <li>{item.mission}</li>
                        ))}
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section 
        data-section="filter"
        className="py-8 bg-gradient-to-b from-slate-100/95 to-slate-200/95"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200 ${
          visibleSections.has('filter') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setFilter(category.id)}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 ${
                  filter === category.id
                    ? 'bg-gradient-to-r from-red-600 to-[#3E3274] text-white shadow-lg shadow-blue-500/50'
                    : 'bg-red-500 text-white hover:text-white hover:bg-slate-700'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section 
        data-section="projects"
        className="py-16 bg-gradient-to-b from-slate-100/95 to-slate-200/95"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-300 ${
          visibleSections.has('projects') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.map((project, index) => (
              <div
                key={project.id}
                className="group relative overflow-hidden rounded-2xl bg-gradient-to-r from-red-500 to-[#3E3274] border border-slate-700 hover:border-white transition-all duration-500 transform hover:scale-105"
                style={{ 
                  transitionDelay: `${index * 100}ms`,
                  animation: 'fadeIn 0.5s ease-out'
                }}
              >
                <div className={`aspect-video bg-gradient-to-br ${project.gradient} relative overflow-hidden`}>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <img src={`${process.env.REACT_APP_BASE_URL}uploads/images/${project.thumb}`} alt="" className="w-full" />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  
                  {/* Hover Overlay */}
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <button
                      onClick={() => {
                        setSelectedProject(project);
                        setCurrentIndex(0);
                      }}
                      className="px-6 py-3 bg-white text-slate-900 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-300"
                    >
                      Lihat Galeri
                    </button>
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2 text-white group-hover:text-white transition-colors duration-300">
                    {project.title}
                  </h3>
                  <p className="text-gray-400 text-sm mb-4">
                    {project.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <Pagination
            current={page}
            total={total}
            onPageChange={setPage}
          />
          {filteredProjects.length === 0 && (
            <div className="text-center py-16">
              <p className="text-gray-400 text-lg">Galeri tidak ditemukan.</p>
            </div>
          )}
        </div>
      </section>

      {/* Team Section */}
      <section 
        data-section="team"
        className="py-24 bg-white"
      >
        <div className={`w-full px-4 py-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-400 ${
          visibleSections.has('team') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="text-center mb-16">
            <h2 className="font-bricolage text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-red-500 to-[#3E3274] bg-clip-text text-transparent">
              Tim Kenzie Komunika
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-red-500 to-[#3E3274] mx-auto mb-4"></div>
            <p className="text-slate-700 text-lg max-w-2xl mx-auto">
              Mereka yang selalu hadir untuk men-support Mitra Kenzie Komunika dengan Integritas tinggi.
            </p>
          </div>

          <div className="w-full grid md:grid-cols-1 gap-8 overflow-hidden">
            <TeamSlider dataTeam={dataTeam}></TeamSlider>
          </div>
        </div>
      </section>
      

      {/* Stats Section */}
      {/* <section 
        data-section="stats"
        className="py-24 bg-gradient-to-b from-slate-900 to-slate-950"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-500 ${
          visibleSections.has('stats') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent">
              Our Impact
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-red-500 mx-auto"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-12">
            {[
              { number: '500+', label: 'Projects Completed', desc: 'Successfully delivered across various industries' },
              { number: '200+', label: 'Happy Clients', desc: 'Building long-term partnerships worldwide' },
              { number: '50+', label: 'Expert Team', desc: 'Dedicated professionals with diverse expertise' },
              { number: '15+', label: 'Years Experience', desc: 'Proven track record of excellence' },
            ].map((stat, index) => (
              <div
                key={index}
                className="flex items-center space-x-6 p-8 bg-slate-800/50 backdrop-blur-sm rounded-2xl border border-slate-700 hover:border-blue-500/50 transition-all duration-300 transform hover:scale-105"
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className={`text-5xl font-bold ${
                  index % 2 === 0 
                    ? 'bg-gradient-to-r from-blue-400 to-cyan-400' 
                    : 'bg-gradient-to-r from-red-400 to-pink-400'
                } bg-clip-text text-transparent`}>
                  {stat.number}
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold mb-1 text-white">{stat.label}</h3>
                  <p className="text-gray-400 text-sm">{stat.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
      {/* CTA Section */}
      <section 
        data-section="cta"
        className="py-24 bg-bg-gradient-to-b from-slate-100/95 to-slate-200/95 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
        </div>

        <div className={`relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 delay-400 ${
          visibleSections.has('cta') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h2 className="font-bricolage text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-red-500 to-[#3E3274] bg-clip-text text-transparent">
            Ayo bergabung menjadi mitra Kami!
          </h2>
          <p className="text-xl text-slate-700 mb-8">
            Kami tidak hanya menyediakan layanan, tetapi membangun kemitraan jangka panjang untuk perkembangan bisnis Anda.
          </p>
          <Link 
            to="/contact"
            className="inline-block text-white px-10 py-4 bg-gradient-to-r from-red-500 to-[#3E3274] rounded-full font-semibold text-lg hover:shadow-2xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300"
          >
            Mulai mendaftar
          </Link>
        </div>
      </section>
      {selectedProject && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">

          {/* Glass Background */}
          <div
            className="absolute inset-0 bg-black/40 backdrop-blur-xl"
            onClick={() => setSelectedProject(null)}
          />

          {/* Modal Content */}
          <div className="
            relative
            w-full
            max-w-6xl
            h-[75vh] md:h-[80vh]
            bg-white/10
            backdrop-blur-2xl
            border border-white/20
            rounded-xl md:rounded-2xl
            overflow-hidden
            shadow-2xl
          ">
            {/* Close Button */}
            <button
              onClick={() => setSelectedProject(null)}
              className="absolute top-3 right-3
                md:top-4 md:right-4
                z-50
                text-white
                text-xl md:text-2xl"
            >
              <X></X>
            </button>

            {/* Slider Content */}
            <div className="relative w-full h-full flex items-center justify-center overflow-hidden">

              {/* Slide */}
              <div
                className="w-full h-full flex transition-transform duration-500 ease-in-out"
                style={{
                  transform: `translateX(-${currentIndex * 100}%)`
                }}
              >
                {selectedProject.items.map((item, index) => (
                  <div
                    key={index}
                    className="w-full p-4 flex-shrink-0 flex items-center justify-center"
                  >
                    {item.filetype === "image" ? (
                      <img
                        src={`${process.env.REACT_APP_BASE_URL}uploads/gallery/${item.filename}`}
                        alt=""
                        className="max-h-[65vh] md:max-h-[70vh] w-auto object-contain rounded-xl"
                      />
                    ) : (
                      <video
                        src={`${process.env.REACT_APP_BASE_URL}uploads/gallery/${item.filename}`}
                        controls
                        className="max-h-[65vh] md:max-h-[70vh] w-auto rounded-xl"
                      />
                    )}
                  </div>
                ))}
              </div>

              {/* Navigation Buttons */}
              <button
                onClick={() =>
                  setCurrentIndex((prev) =>
                    prev === 0
                      ? selectedProject.items.length - 1
                      : prev - 1
                  )
                }
                className="absolute left-4 text-white text-3xl transform hover:scale-125 duration-500"
              >
                <ChevronLeftCircle size={48}></ChevronLeftCircle>
              </button>

              <button
                onClick={() =>
                  setCurrentIndex((prev) =>
                    prev === selectedProject.items.length - 1
                      ? 0
                      : prev + 1
                  )
                }
                className="absolute right-4 text-white text-3xl  transform hover:scale-125 duration-500"
              >
                <ChevronRightCircle size={48}></ChevronRightCircle>
              </button>

            </div>
          </div>
        </div>
      )}

    </div>
  );
}
